(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function lockScroll(on) {
    document.documentElement.classList.toggle('om-v3-scroll-lock', on);
    document.body.classList.toggle('om-v3-scroll-lock', on);
  }

  /* ── Announcement-höjd -> --om-announce-h ──
     Hero-kortet räknar sin min-height bakåt från 100svh. Topbaren är sticky (top:0)
     men announcement-raden ovanför den rullar med, så vid scrollPos 0 äter den höjd
     som hero annars lägger UNDER det fixade bottennavet — hela nederkanten inkl.
     radien försvann. Mät baren och låt CSS dra av den. */
  var announceBound = false;

  function initAnnounceHeight() {
    function measure() {
      var bar = qs('.announcement__bar');
      var h = bar ? bar.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty('--om-announce-h', Math.round(h) + 'px');
    }

    measure();

    /* initAll körs om på shopify:section:load — mät om, men bind bara en gång. */
    if (announceBound) return;
    announceBound = true;
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
  }

  /* ── Förvärm kundvagns-drawern ──
     Temat skickar bara ett skelett i markupen (cart__items--blankstate). Riktiga
     rader hämtas först på theme:drawer:open: loadHTML -> loadForm ->
     fetch('?section_id=api-cart-items') -> innerHTML, och FÖRST DÄREFTER börjar
     radbilderna laddas — mitt i öppningsanimationen. Därav hacket.
     Vi rör inte temats state-maskin; vi värmer bara HTTP-cachen i förväg så att
     både sektions-HTML och bilder redan ligger där när drawern öppnas. */
  var cartWarmToken = 0;

  function warmCartDrawer() {
    if (!qs('#drawer-cart')) return;
    var root = (window.theme && window.theme.routes && window.theme.routes.root_url) || '/';
    var token = ++cartWarmToken;

    fetch(root + '?section_id=api-cart-items', { credentials: 'same-origin' })
      .then(function (r) {
        return r.ok ? r.text() : null;
      })
      .then(function (html) {
        /* En nyare varmning har hunnit starta -> släng den här. */
        if (!html || token !== cartWarmToken) return;
        var box = document.createElement('div');
        box.innerHTML = html;
        qsa('img', box).forEach(function (img) {
          var src = img.getAttribute('src');
          if (!src) return;
          var pre = new Image();
          var srcset = img.getAttribute('srcset');
          var sizes = img.getAttribute('sizes');
          /* sizes/srcset innan src, annars väljer webbläsaren fel kandidat och
             vi värmer en URL som sedan inte används. */
          if (sizes) pre.sizes = sizes;
          if (srcset) pre.srcset = srcset;
          pre.src = src;
          if (pre.decode) pre.decode().catch(function () {});
        });
      })
      .catch(function () {});
  }

  /* ── Sticky ATC-barens höjd -> --om-sticky-atc-h ──
     PDP:ns köp-bar och "tillagd"-notisen ankras båda strax ovanför bottennavet.
     Utan den här mätningen lägger sig notisen ovanpå köpknappen. Baren finns
     bara på produktsidor och kan togglas, så mät den i stället för att gissa. */
  function initStickyAtcHeight() {
    var root = document.documentElement;

    function measure() {
      var atc = qs('.om-sticky-atc');
      var h = 0;
      if (atc) {
        var r = atc.getBoundingClientRect();
        /* Baren finns i DOM även när den är utanför skärmen — räkna bara den
           som tar plats just nu. */
        if (r.height && getComputedStyle(atc).display !== 'none' && r.top < window.innerHeight) {
          h = r.height;
        }
      }
      root.style.setProperty('--om-sticky-atc-h', Math.round(h) + 'px');
    }

    measure();
    window.addEventListener('resize', measure);
    document.addEventListener('theme:scroll', measure);
    return measure;
  }
  var cartWarmBound = false;

  function initCartWarm() {
    if (typeof fetch === 'undefined' || cartWarmBound) return;
    cartWarmBound = true;

    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 400); };
    idle(function () { warmCartDrawer(); });

    /* Cachen blir kall så fort varukorgen ändras. */
    document.addEventListener('theme:cart:reload', function () { idle(function () { warmCartDrawer(); }); });
    document.addEventListener('theme:cart:added', function () { idle(function () { warmCartDrawer(); }); });
  }

  /* ── Kundvagns-sheetens öppet-läge -> body.om-cart-open ──
     Speglar temats drawer--visible. aria-expanded duger inte: Pipelines hideDrawer()
     sätter den till true igen (theme.dev.js), så den är alltid true efter första
     öppningen. Klassen på #drawer-cart är sanningen. */
  var cartObserved = null;

  function initCartDrawerState() {
    var drawer = qs('#drawer-cart');
    if (!drawer || typeof MutationObserver === 'undefined') return;

    function sync() {
      document.body.classList.toggle('om-cart-open', drawer.classList.contains('drawer--visible'));
    }

    sync();

    /* Header-sektionen renderas om i theme editor -> ny nod, ny observer. Samma
       nod två gånger ska däremot inte ge dubbla observers. */
    if (cartObserved === drawer) return;
    cartObserved = drawer;
    new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  /* ── Mobile chrome: search + menu (bottom nav or topbar) ── */
  function initMobileTopbar() {
    var searchBtns = qsa('[data-om-search-toggle]');
    var menuBtns = qsa('[data-om-menu-toggle]');
    if (!searchBtns.length && !menuBtns.length) return;

    searchBtns.forEach(function (searchBtn) {
      searchBtn.addEventListener('click', function (e) {
        e.preventDefault();
        openSearchOverlay(searchBtn);
      });
    });

    menuBtns.forEach(function (menuBtn) {
      menuBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var drawerToggle = qs('[data-drawer-toggle="hamburger"]');
        if (drawerToggle) drawerToggle.click();
      });
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-close-popdown]') || e.target.closest('[data-search-underlay]')) {
        closeSearchOverlay(searchBtns[0] || null);
      }
    });
  }

  function setSearchOpen(on, searchBtn) {
    document.body.classList.toggle('om-v3-search-open', on);
    lockScroll(on);
    if (searchBtn) searchBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
  }

  function focusSearchInput() {
    setTimeout(function () {
      var input = qs('#search-popdown [data-predictive-search-input]');
      if (input) input.focus();
    }, 120);
  }

  function openSearchOverlay(searchBtn) {
    var popdown = document.getElementById('search-popdown');
    if (popdown && popdown.classList.contains('is-visible')) {
      closeSearchOverlay(searchBtn);
      return;
    }
    setSearchOpen(true, searchBtn);
    var popdownToggle = qs('[data-popdown-toggle="search-popdown"]');
    if (popdownToggle) popdownToggle.click();
    focusSearchInput();
  }

  function closeSearchOverlay(searchBtn) {
    setSearchOpen(false, searchBtn);
  }

  /* ── Desktop + shared search overlay sync ── */
  function initSearchOverlay() {
    var popdown = document.getElementById('search-popdown');
    if (!popdown) return;

    var searchBtn = qs('[data-om-search-toggle]');
    var desktopToggle = qs('[data-popdown-toggle="search-popdown"]');

    function syncFromPopdown() {
      var open = popdown.classList.contains('is-visible');
      setSearchOpen(open, searchBtn);
      if (open) focusSearchInput();
    }

    if (desktopToggle) {
      desktopToggle.addEventListener('click', function () {
        window.setTimeout(syncFromPopdown, 0);
      });
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-close-popdown]')) {
        window.setTimeout(function () {
          if (!popdown.classList.contains('is-visible')) closeSearchOverlay(searchBtn);
        }, 0);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popdown.classList.contains('is-visible')) {
        var closeBtn = qs('[data-close-popdown]', popdown);
        if (closeBtn) closeBtn.click();
      }
    });

    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(syncFromPopdown);
      observer.observe(popdown, { attributes: true, attributeFilter: ['class'] });
    }
  }

  /* ── Desktop tab mega menu ── */
  function initTabMega() {
    var mega = qs('[data-om-tab-mega]');
    if (!mega) return;

    var toggle = qs('[data-om-tab-toggle]');
    var headerSection = qs('[id$="__header"].shopify-section-group-group-header');
    var tabs = qsa('[data-om-tab]', mega);
    var panels = qsa('[data-om-panel]', mega);

    function setOpen(open) {
      mega.classList.toggle('is-open', open);
      if (headerSection) headerSection.classList.toggle('om-mega-open', open);
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      lockScroll(open);
    }

    function activateTab(id) {
      tabs.forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-om-tab') === id);
      });
      panels.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-om-panel') === id);
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-om-tab');
        activateTab(id);
        tabs.forEach(function (t) {
          t.setAttribute('aria-selected', t.getAttribute('data-om-tab') === id ? 'true' : 'false');
        });
      });
    });

    if (tabs.length) {
      var first = tabs[0].getAttribute('data-om-tab');
      activateTab(first);
      tabs[0].setAttribute('aria-selected', 'true');
    }

    if (toggle) {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var open = !mega.classList.contains('is-open');
        setOpen(open);
        mega.setAttribute('aria-hidden', open ? 'false' : 'true');
      });
    }

    document.addEventListener('click', function (e) {
      if (!mega.classList.contains('is-open')) return;
      if (e.target.closest('[data-om-tab-mega]') || e.target.closest('[data-om-tab-toggle]')) return;
      setOpen(false);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mega.classList.contains('is-open')) setOpen(false);
    });
  }

  /* ── Hero slider: infinite loop + autoplay + fraction progress bar ── */
  function initHeroSliders(root) {
    qsa('[data-om-hero-slider]', root).forEach(function (el) {
      if (el.__omHeroInit) return;
      el.__omHeroInit = true;

      var track = qs('[data-om-hero-track]', el);
      var realSlides = qsa('[data-om-hero-slide]', el);
      var currentEl = qs('[data-om-hero-current]', el);
      var fillEl = qs('[data-om-hero-progress-fill]', el);
      if (!track || realSlides.length < 2) return;

      var n = realSlides.length;

      /* ── Endless strip via periodic re-centering ──────────────────────────
         Two edge clones are not enough: while a finger is still down the
         browser will not scroll past the physical end of the track, so a
         continuous drag hits a wall and only frees up after release, once a
         debounced handler can teleport. That is the "it sticks at the end"
         behaviour.

         Instead lay out THREE copies of the slide set and keep the scroll
         position inside the middle copy. When it drifts out, shift it by
         exactly one period (n * slideWidth). Because the strip is periodic,
         the pixels under the finger are identical before and after the shift
         — so it can be done mid-drag, invisibly, and there is never an end to
         reach in either direction.                                          */
      function makeClone(node) {
        var c = node.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.setAttribute('data-om-hero-clone', '');
        c.removeAttribute('id');
        qsa('[id]', c).forEach(function (x) { x.removeAttribute('id'); });
        qsa('a, button, input, select, textarea, [tabindex]', c).forEach(function (x) {
          x.setAttribute('tabindex', '-1');
        });
        return c;
      }

      var before = document.createDocumentFragment();
      var after = document.createDocumentFragment();
      realSlides.forEach(function (s) { before.appendChild(makeClone(s)); });
      realSlides.forEach(function (s) { after.appendChild(makeClone(s)); });
      track.insertBefore(before, realSlides[0]);
      track.appendChild(after);

      // Collected after cloning so the cloned mobile dot rows stay in sync too.
      var dots = qsa('[data-om-hero-dot]', el);

      var index = 0;      // real slide, 0..n-1
      var timer;
      var paused = false;
      var adjusting = false;

      function period() { return n * track.clientWidth; }

      // Instant, non-animated reposition. Snap must be off for the duration or
      // the browser animates the shift and fights the assignment.
      function hardSet(x) {
        adjusting = true;
        var prevSnap = track.style.scrollSnapType;
        var prevBehavior = track.style.scrollBehavior;
        track.style.scrollSnapType = 'none';
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = x;
        void track.offsetWidth;
        track.style.scrollSnapType = prevSnap;
        track.style.scrollBehavior = prevBehavior;
        adjusting = false;
      }

      // Keep the scroll offset inside the middle copy, [P, 2P). Runs on every
      // scroll event — including while the finger is down — but only actually
      // shifts once per period of travel, so it is cheap and imperceptible.
      function recenter() {
        if (adjusting) return;
        var P = period();
        if (!P) return;
        var x = track.scrollLeft;
        if (x < P * 0.5) hardSet(x + P);
        else if (x >= P * 1.5) hardSet(x - P);
      }

      function readIndex() {
        var w = track.clientWidth;
        if (!w) return index;
        return ((Math.round(track.scrollLeft / w) % n) + n) % n;
      }

      function resetBar() {
        if (!fillEl) return;
        fillEl.classList.remove('is-animating');
        fillEl.style.removeProperty('animation');
        fillEl.style.transform = 'scaleX(0)';
      }

      function animateBar() {
        if (!fillEl || REDUCED || paused) return;
        var speed = parseInt(el.getAttribute('data-autoplay-ms') || '7000', 10);
        el.style.setProperty('--om-hero-autoplay-ms', speed + 'ms');
        resetBar();
        void fillEl.offsetWidth;
        fillEl.style.removeProperty('transform');
        requestAnimationFrame(function () {
          fillEl.classList.add('is-animating');
        });
      }

      function updateUI(animateBarNow) {
        if (currentEl) currentEl.textContent = String(index + 1);
        // Dots may appear once (desktop nav) or once per slide (mobile copy),
        // and every copy of the strip carries its own. Match by 1-based label
        // ("01") rather than array index.
        dots.forEach(function (dot) {
          var label = parseInt((dot.textContent || '').replace(/\D/g, ''), 10);
          dot.classList.toggle('is-active', label === index + 1);
        });
        if (!fillEl) return;
        if (animateBarNow) animateBar();
        else resetBar();
      }

      // Always advances one cell to the right. recenter() guarantees there is
      // always more strip in that direction, so this never rewinds.
      function tick() {
        var w = track.clientWidth;
        if (!w) return;
        var cell = Math.round(track.scrollLeft / w);
        index = (((cell + 1) % n) + n) % n;
        updateUI(true);
        track.scrollTo({ left: (cell + 1) * w, behavior: REDUCED ? 'auto' : 'smooth' });
      }

      function restart() {
        clearInterval(timer);
        if (REDUCED || paused) return;
        animateBar();
        var speed = parseInt(el.getAttribute('data-autoplay-ms') || '7000', 10);
        timer = setInterval(tick, speed);
      }

      // Re-centering mid-gesture killed the momentum and could leave the track
      // resting between two slides. Deliberately reverted: only re-center once
      // scrolling has come to rest. The trade-off is the known one — a single
      // uninterrupted drag can still reach the end of the strip and stop there
      // until you lift your thumb — which is accepted behaviour.
      var settleTimer;
      track.addEventListener('scroll', function () {
        var next = readIndex();
        if (next !== index) {
          index = next;
          updateUI(false);
          if (!paused) restart();
        }
        clearTimeout(settleTimer);
        settleTimer = window.setTimeout(recenter, 120);
      }, { passive: true });

      var dragPointerId = null;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        dragPointerId = e.pointerId;
        paused = true;
        clearInterval(timer);
        resetBar();
      });

      function endDrag() {
        dragPointerId = null;
        paused = false;
        restart();
      }

      track.addEventListener('pointerup', function (e) {
        if (dragPointerId !== null && e.pointerId !== dragPointerId) return;
        endDrag();
      });

      track.addEventListener('pointercancel', endDrag);

      // Slide widths are viewport-relative, so the period changes on resize —
      // and this script can run before the hero has any layout at all, when
      // clientWidth is still 0. Re-anchor whenever the width actually changes.
      var lastWidth = 0;
      function anchor() {
        var w = track.clientWidth;
        if (!w || w === lastWidth) return;
        lastWidth = w;
        hardSet(period() + index * w);   // middle copy, current slide
      }

      if (window.ResizeObserver) {
        new ResizeObserver(anchor).observe(track);
      } else {
        var resizeTimer;
        window.addEventListener('resize', function () {
          clearTimeout(resizeTimer);
          resizeTimer = window.setTimeout(anchor, 150);
        });
        window.addEventListener('load', anchor);
      }

      anchor();
      updateUI(true);
      restart();
    });
  }

  /* ── Predictive search: same engine as the results page ──────────────────
     theme.js drives the dropdown off /search/suggest.json, which is a
     DIFFERENT index from the /search results page: it matches title and
     product_type only, and never sees tags or descriptions. Measured on this
     catalogue, "pretty sure" returned 0 suggestions but 7 real results — the
     dropdown was hiding products the shopper would have found by pressing
     enter. Two engines that disagree is worse than one slower engine.

     So we take the input over and render from /search?view=suggest instead:
     same route, same ranking, cannot disagree. Cost is ~4.4 KB per keystroke
     versus suggest.json's ~8 KB, and timing is within noise.                */
  function initPredictiveSearch(root) {
    qsa('[data-predictive-search-input]', root).forEach(function (input) {
      if (input.__omSearchInit) return;

      // theme.js binds its own listener to this element. Replacing the node
      // with a clone drops every listener attached to it, so only ours runs
      // and the two engines can't race to write into the same container.
      var el = input.cloneNode(true);
      input.parentNode.replaceChild(el, input);
      el.__omSearchInit = true;

      var form = el.closest('form');
      var scope = el.closest('.om-search-overlay, .search__predictive__outer') || document;
      var results = qs('[data-predictive-search-results]', scope);
      var browse = qs('.om-search-overlay__grid, [data-om-search-browse]', scope);
      if (!results) return;

      var controller = null;
      var timer = null;

      function setBrowsing(on) {
        // The pre-typing collection tiles and the result list are mutually
        // exclusive — showing both reads as two competing answers.
        if (browse) browse.hidden = !on;
        results.hidden = on;
      }

      function clear() {
        if (controller) { controller.abort(); controller = null; }
        results.innerHTML = '';
        setBrowsing(true);
      }

      function run(term) {
        if (controller) controller.abort();
        controller = ('AbortController' in window) ? new AbortController() : null;

        var url = window.theme && window.theme.routes && window.theme.routes.search_url
          ? window.theme.routes.search_url
          : '/search';
        url += '?q=' + encodeURIComponent(term) + '&type=product&view=suggest';

        results.setAttribute('aria-busy', 'true');
        fetch(url, controller ? { signal: controller.signal } : undefined)
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            if (!html) return;
            results.innerHTML = html;
            setBrowsing(false);
            results.removeAttribute('aria-busy');
          })
          .catch(function (err) {
            // An aborted keystroke is expected, not a failure.
            if (!err || err.name !== 'AbortError') results.removeAttribute('aria-busy');
          });
      }

      el.addEventListener('input', function () {
        var term = el.value.trim();
        clearTimeout(timer);
        if (term.length < 2) { clear(); return; }
        timer = window.setTimeout(function () { run(term); }, 220);
      });

      el.addEventListener('search', function () { if (!el.value.trim()) clear(); });
      if (form) form.addEventListener('reset', function () { window.setTimeout(clear, 0); });

      setBrowsing(true);
    });
  }

  /* ── Product gallery slow autoplay ── */
  function initGalleryAutoplay(root) {
    qsa('[data-om-gallery-autoplay="true"]', root).forEach(function (grid) {
      if (grid.__omGalleryInit) return;

      function attach() {
        var flkty = window.Flickity && window.Flickity.data(grid);
        if (!flkty || typeof flkty.select !== 'function' || flkty.cells.length < 2) return false;

        grid.__omGalleryInit = true;
        var index = flkty.selectedIndex || 0;
        var timer;

        function advance() {
          index = (index + 1) % flkty.cells.length;
          flkty.select(index);
        }

        function start() {
          clearInterval(timer);
          if (REDUCED || document.hidden) return;
          var ms = parseInt(grid.getAttribute('data-autoplay-ms') || '6000', 10);
          timer = setInterval(advance, ms);
        }

        grid.addEventListener('mouseenter', function () {
          clearInterval(timer);
        });
        grid.addEventListener('touchstart', function () {
          clearInterval(timer);
        }, { passive: true });

        document.addEventListener('visibilitychange', start);
        start();
        return true;
      }

      if (!attach()) {
        setTimeout(function () {
          attach();
        }, 1200);
      }
    });
  }

  /* ── Navbaren glider fram till en pill medan man scrollar ──
     --om-nav-p går 0 -> 1 över de första PILL_RANGE pixlarna. CSS interpolerar
     inset, radie och skuggans opacitet mot den, så pillen följer scrollen i stället
     för att poppa fram på en tröskel. Att den är helt formad innan hero-kortet
     hinner fram gör också att kortets kapade överkant möter en mjuk skugga, inte
     en hård kant. */
  var PILL_RANGE = 96;

  function stickyBar() {
    var bar = qs('.om-mobile-topbar');
    if (bar && bar.offsetParent !== null) return bar;
    return qs('.theme__header');
  }

  /* Sökoverlayen behöver veta var baren slutar. Publiceras som CSS-variabel. */
  function publishChromeHeight() {
    var bar = stickyBar();
    if (!bar) return;
    var rect = bar.getBoundingClientRect();
    document.documentElement.style.setProperty(
      '--om-chrome-h',
      Math.round(Math.max(rect.bottom, rect.height)) + 'px'
    );
  }

  var navPillBound = false;
  function initNavPill() {
    publishChromeHeight();
    if (navPillBound) return; // initAll körs igen på shopify:section:load
    navPillBound = true;

    var frame = null;

    /* Pill-morfen är avstängd: headern ska förbli rektangulär och full bredd
       vid scroll. --om-nav-p lämnas därför på sitt :root-värde 0, vilket ger
       ::before/::after inset:0 + radius:0 — ytan finns kvar, men platt.
       Funktionen är kvar för att den också publicerar --om-chrome-h, som
       om-v3.css:1515-1522 använder för sökoverlayens höjd/offset. */
    function update() {
      frame = null;
      publishChromeHeight();
    }

    function schedule() {
      if (frame === null) frame = requestAnimationFrame(update);
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    update();
  }

  /* ── Sticky köp-bar på produktsidan ──
     Speglar den riktiga köpknappen (text, pris, disabled) och skickar klicket
     vidare till den. Inget eget formulär, så variant-/pris-/sold-out-logiken har
     fortfarande exakt en ägare. Baren visas när den riktiga knappen är utanför
     bild — samma mönster som Zara. */
  function initStickyAtc() {
    var bar = qs('[data-om-sticky-atc]');
    if (!bar || bar.__omInit) return;

    var real = qs('[data-add-to-cart]');
    if (!real) return;
    bar.__omInit = true;

    var proxy = qs('[data-om-sticky-atc-btn]', bar);
    var label = qs('[data-om-sticky-atc-label]', bar);
    var price = qs('[data-om-sticky-atc-price]', bar);

    function sync() {
      var realLabel = qs('[data-add-to-cart-text]', real);
      var realPrice = qs('[data-button-price]', real);
      if (realLabel) label.textContent = realLabel.textContent.trim();
      if (realPrice) price.textContent = realPrice.textContent.trim();
      var off = real.hasAttribute('disabled');
      proxy.disabled = off;
      bar.classList.toggle('is-unavailable', off);
    }

    function setVisible(on) {
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      proxy.tabIndex = on ? 0 : -1;
    }

    proxy.addEventListener('click', function () {
      real.click();
    });

    sync();
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(sync).observe(real, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['disabled'],
      });
    }

    if (typeof IntersectionObserver !== 'undefined') {
      new IntersectionObserver(function (entries) {
        setVisible(!entries[0].isIntersecting);
      }).observe(real);
    }
  }

  function initAll(root) {
    initAnnounceHeight();
    initStickyAtcHeight();
    initCartDrawerState();
    initCartWarm();
    initMobileTopbar();
    initNavPill();
    initStickyAtc();
    initSearchOverlay();
    initTabMega();
    initHeroSliders(root || document);
    initGalleryAutoplay(root || document);
    initPredictiveSearch(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
